import { AdminProfessionals } from '@platform/client';
import { Button, FormsInputDropdown, InputDropdownItem } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { GetCohortsByClientsResponse } from '@platform/client/schemas';
import { navigate } from 'wouter/use-browser-location';
import { ADMIN_ROUTES, ROUTES } from '../../../routes/consts';

/** The teams admin page is simply a form to select a cohort. The selection prompts a redirect to the CohortTeams page */
const TeamsAdmin = () => {
  return (
    <div className='px-4 md:px-20'>
      <CohortSelectionForm />
    </div>
  );
};

type CohortSelectionFormData = {
  clientId: number | null;
  cohortId: number | null;
};

const CohortSelectionForm = () => {
  const { data: cohortsByClient } = AdminProfessionals.useGetCohortsByClients({
    current_only: true,
  });
  const { control, handleSubmit, watch, formState } = useForm<CohortSelectionFormData>();
  const selectedClientId = watch('clientId');
  const { clientItems, cohortItems } = mapClientsToDropdownItems(cohortsByClient, selectedClientId);
  const onSubmit: SubmitHandler<CohortSelectionFormData> = (data) => {
    if (data.cohortId) {
      navigate(`/platform${ROUTES.ADMIN}${ADMIN_ROUTES.TEAMS}/${data.cohortId}`);
    }
  };

  return (
    <form className='md:flex items-start gap-3'>
      <FormsInputDropdown
        label='Client'
        control={control}
        name='clientId'
        type='default'
        items={clientItems}
        placeholder='Select Client'
        rules={{ required: 'Client required' }}
        error={formState.errors.clientId}
      />
      <FormsInputDropdown
        label='Cohort'
        control={control}
        name='cohortId'
        type='default'
        items={cohortItems}
        placeholder='Select Cohort'
        rules={{ required: 'Cohort required' }}
        error={formState.errors.cohortId}
      />
      <Button
        variant='primary'
        size='sm'
        additionalClassnames='mt-8'
        onPress={() => handleSubmit(onSubmit)()}
      >
        Get teams
      </Button>
    </form>
  );
};

const mapClientsToDropdownItems = (
  clientData: GetCohortsByClientsResponse | undefined,
  selectedClientId: number | null,
): {
  clientItems: InputDropdownItem[];
  cohortItems: InputDropdownItem[];
} => {
  const clientItems =
    clientData?.clients.map((client) => ({
      text: client.name,
      textValue: client.id,
    })) || [];

  const selectedClient = clientData?.clients.find((client) => client.id == selectedClientId);
  const cohortItems =
    selectedClient?.cohorts.map((cohort) => ({
      text: cohort.name,
      textValue: cohort.id,
    })) || [];
  return {
    clientItems,
    cohortItems,
  };
};

export default TeamsAdmin;
